var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup-container",on:{"click":function($event){if($event.target !== $event.currentTarget)return null;return _vm.closePopup.apply(null, arguments)}}},[_c('div',{staticClass:"popup",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"popup-content"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }